<cxone-modal [headerTitle]="headerTitle" [modalSize]="'m'" [focusOnShow]="true" (dismissed)="close()" (closed)="close()"
    [customFooter]="true" #modalDialog id="cxone-modal">
    <div class="recalculation-details-dialog-body cx-one-ui" [style.pointer-events]="loading ? 'none' : 'auto'"
        id="recalculation-details-dialogBody">
        <div class="feed-section" id="feed-section">
            <div class="input-header" id="recalculate-date-header">
                <span class="label" cvLocalizedText langSection="Manage_Metrics_Recalculation"
                    langKey="Recalculation_Date" id="recalculate-date-label">
                    Recalculation Date
                </span>
                <br>
                <span class="data">{{recalculateDate}}</span>
            </div>
            <div class="input-header" id="initiated-by-header" *ngIf="!isRecalculationComplete">
                <span class="label" cvLocalizedText langSection="Manage_Metrics_Recalculation" langKey="Initiated_By"
                    id="initiated-by-label">
                    Initiated By
                </span>
                <br>
                <span class="data">{{initiatedBy}}</span>
            </div>
            <div class="input-header" id="definitions-header">
                <span class="label" cvLocalizedText langSection="Manage_Metrics_Recalculation" langKey="Definitions"
                    id="definitions-label">
                    Definitions
                </span>
                <br>
                <span class="data">{{definition}}</span>
            </div>
            <div class="input-header" id="last-modified-header">
                <span class="label" cvLocalizedText langSection="Manage_Metrics_Recalculation" langKey="Last_Modified"
                    id="last-modified-label">
                    Last Modified
                </span>
                <br>
                <span class="data">{{lastModifiedDate}}</span>
            </div>
        </div>
    </div>
    <cxone-modal-footer [style.pointer-events]="loading ? 'none' : 'auto'">
        <div class="recalculation-detials-dialog-footer cx-one-ui"
            id="manage-metrics-recalculation-detials-dialog-footer">
            <button cvLocalizedText langSection="Manage_Metrics_Recalculation" langKey="Close_Button" (click)="close()"
                id="close-button" class="cxone-btn btn-md btn-secondary" tabindex="0">
                Close
            </button>
        </div>
    </cxone-modal-footer>
</cxone-modal>